import React, {Component} from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {Carousel, Layout, message, Modal, notification} from 'antd'
import { Icon } from '@ant-design/compatible';
import moment from "moment";

import SideBar from '../sidebar/SideBar'
import Header from '../header/Header'
import UsuarioFormulario from '../../../pages/usuario/formulario/UsuarioFormulario';
import ConfiguracaoGeralFormulario from '../../../pages/configuracaoGeral/ConfiguracaoGeralFormulario';
import {logOut, updateProfile} from '../../../redux/account/account.actions'
import {addNewNotification, readNotification} from "../../../redux/notification/notification.actions";
import { getConfiguration } from '../../services/http/RevendaService';
import {find as findUser, getMenus} from '../../services/http/UsuarioService';
import {QuadrosAvisoService} from "../../services/http/QuadrosAvisoService";
import {markOrderAsRead, watchResaleNewOrders} from "../../services/http/PedidoService"
import {organizacaoService} from "../../services/http/OrganizacaoService"
import {
  getUser,
  isOrganization,
  isResale,
  isUpgasEmployee,
  isUserResale
} from '../../services/UserService';
import OrderSoundPlayer from "../order-sound-player/OrderSoundPlayer"
import './Layout.scss'
import {termosECondicoes} from "../../services/TermosECondicoesService";
import DetalhePedido from '../../../pages/pedidos/detalhe/DetalhePedido'


export const SUSPENDED_ORGANIZATION_NOTIFICATION_KEY = "SUSPENDED_ORGANIZATION_NOTIFICATION"
export const CLOSED_RESALES_NOTIFICATION_KEY = "CLOSED_RESALES_NOTIFICATION"
export const REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION_KEY = "REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION"
export const PENDENT_BILLET_NOTIFICATION_KEY = "REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION"

class UpgasLayout extends Component {
  constructor(props) {
    super(props)

    const soundMutedOnStorage = localStorage.getItem("notification-bell-muted")

    this.state = {
      collapsed: false,
      userFormIsOpen: false,
      resaleRatioFormIsOpen: false,
      loadingMenus: isUpgasEmployee(),
      employeeMenus: [],
      user: {},
      configuration: { ratio: 0, contribuitionPercent: 0 },
      isSoundMuted: soundMutedOnStorage ? JSON.parse(soundMutedOnStorage) : false,
      pedidoSelecionado: false,
      orderId: ''
    }

    this.unsubscribeNewOrders = null
  }

  componentDidMount() {
    if (isUpgasEmployee())
      this.getEmployeeMenus()

    if (isOrganization()) {
      const { account } = this.props;

      this.getOrganizationData()
      this.getOrganizationResalesData()
      this.getOrganizationNotices()
      this.watchNewOrders(account.id, account.role)
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeNewOrders) {
      this.unsubscribeNewOrders()
    }

    [CLOSED_RESALES_NOTIFICATION_KEY, REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION_KEY, SUSPENDED_ORGANIZATION_NOTIFICATION_KEY]
      .forEach(key => notification.close(key))
  }

  getEmployeeMenus = () => {
    getMenus(getUser().userId)
      .then(res => this.setState({ employeeMenus: res }))
      .catch(() => message.error('Falha ao obter informação de menus'))
      .finally(() => this.setState({ loadingMenus: false }))
  }

  getOrganizationData = () => {
    const { id } = getUser()

    organizacaoService.getById(id)
      .then(organization => {
        if (organization.suspensa) {
          this.openFixedNotifications({
            key: SUSPENDED_ORGANIZATION_NOTIFICATION_KEY,
            message: 'A sua organização está suspensa',
            description: 'A sua organização está suspensa e NÃO está visível para os clientes. Por favor entre em contato com o Upgas',
          })
        }

        if (organization.termosECondicoes === termosECondicoes.Recusou.Enum) {
          this.openFixedNotifications({
            key: REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION_KEY,
            message: 'Você ainda não aceitou os Termos & Condições da plataforma Upgas',
            description: 'Para seguir recebendo pedidos pelo App, por favor leia os Termos com atenção e clique em aceitar'
          })
        }

        if (organization.possuiBoletosPendentes) {
          const today = new Date()
          const lastSeenDay = organizacaoService.getBilletNotificationLastSeenDay()
          const seenToday = moment(lastSeenDay).isSame(moment(today), 'day')

          if (!seenToday) {
            this.openFixedNotifications({
              key: PENDENT_BILLET_NOTIFICATION_KEY,
              message: 'Chegou um boleto para você!',
              description: 'Clique aqui, vá em "documentos" para visualiza-lo!',
              onClick: () => this.props.history.push('/financas/balancos')
            })

            organizacaoService.updateBilletNotificationLastSeenDay(today)
          }
        }
      })
      .catch(err => message.error(err))
  }

  getOrganizationResalesData = () => {
    organizacaoService.getResales()
      .then(resales => {
        const closedResales = resales.filter(({ disponibilidade }) => !disponibilidade);
        const closedResalesLength = resales.filter(({ disponibilidade }) => !disponibilidade).length

        if (closedResalesLength > 0) {
          const closedResaleNames = closedResales
            .slice(0, 5)
            .map(({ nomeFantasia }) => nomeFantasia)
            .join(' - ')

          this.openFixedNotifications({
            key: CLOSED_RESALES_NOTIFICATION_KEY,
            message: 'Revendas fechadas',
            description: `Você está com ${closedResalesLength} ${
              closedResalesLength > 1 ? 'revendas fechadas' : 'revenda fechada'
            }: ${closedResaleNames}${
              closedResalesLength > 5 ? `\n...e mais ${closedResalesLength - 5} revendas` : ''
            }`
          })
        }
      })
      .catch(err => message.error(err))
  }

  getOrganizationNotices = async () => {
    try {
      const avisos = await QuadrosAvisoService().getResaleAvisos()
      const notReadAvisos = avisos.filter(({ id }) => !QuadrosAvisoService().getReadAvisos().includes(id))

      if (notReadAvisos.length === 0)
        return

      Modal.info({
        title: 'Avisos',
        width: 1000,
        bodyStyle: { height: 320, overflowY: "scroll" },
        onOk: () => QuadrosAvisoService().setAvisosAsRead(notReadAvisos.map(({ id }) => id)),
        content: (
          <Carousel autoplay autoplaySpeed={3500}>
            {notReadAvisos.map(({ titulo, aviso, imagem }, index) => (
              <div key={index}>
                <h1>{titulo}</h1>
                <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>{aviso}</p>
                {imagem && imagem !== '' && <img className="aviso-imagem" src={imagem} alt="imagem do aviso"/>}
              </div>
            ))}
          </Carousel>
        )
      })
    } catch (e) {
      message.error('Falha ao obter avisos')
    }
  }

  watchNewOrders = (id, role) => {
    this.unsubscribeNewOrders = watchResaleNewOrders(id, role, (orders) => {
      const { notifications } = this.props
      const notReadOrders = orders.filter(({ Read }) => !Read)
      const notReadOrdersNotifications = notReadOrders.map(order => ({
        id: order.OrderId,
        read: order.read || false,
        title: 'Existe um novo pedido',
        icon: 'shopping-cart',
        date: moment(),
        action: data => {
          markOrderAsRead(data.id)
            .then(() => this.props.history.push(`/dashboard/operacao`, { id: order.OrderId }))
        },
        payload: order
      }))

      console.log(notReadOrders)
      if (!notReadOrders || notReadOrders.length == 0) {
        this.setState({ isSoundEnabled: false })
        Modal.destroyAll()
        return
      }

      // TODO: ver se esse snapshot sempre traz tudo ou depois só traz os novos! (dá pra tentar simplificar codigo)
      const newNotifications = notReadOrdersNotifications.filter(n => !notifications.find(x => x.id === n.id))

      if (newNotifications.length > 0) this.setState({ isSoundEnabled: true })

      newNotifications.forEach(notification => {
        this.props.addNewNotification(notification)

        this.openNotification(notification)
        this.openModal(notification)
      })
    })
  }

  openNotification = data => {
    notification.open({
      key: data.id,
      onClick: () => this.onNotificationClick(data),
      placement: "bottomRight",
      message: 'Existe um novo pedido',
      description: 'Um novo pedido acaba de ser solicitado.',
      icon: <Icon type={data.icon} style={{ color: '#108ee9' }} />,
    })
  }

  openFixedNotifications = ({ description, message, key, onClick }) => {
    notification.open({
      className: 'fixed-notification',
      key,
      message,
      description,
      duration: null,
      placement: "bottomRight",
      onClick
    })
  }

  onNotificationClick = data => {
    data.action(data.payload)
    notification.close(data.id)
    this.props.readNotification(data)
  }

  openModal = data => {
    Modal.info({
      title: 'Existe um novo pedido',
      okText: 'Ir para o pedido',
      maskClosable: true,
      content: (
        <section>
          <p>Um novo pedido acaba de ser solicitado.</p>
        </section>
      ),
      onOk: () => {
        //data.action(data.payload)
        this.props.readNotification(data)

        this.setState({
          pedidoSelecionado: true,
          orderId: data.id,
        })
      },
    })
  }

  toggleSoundMute = () => {
    localStorage.setItem("notification-bell-muted", (!this.state.isSoundMuted).toString())
    this.setState({ isSoundMuted: !this.state.isSoundMuted })
  }

  toggle = () => this.setState(({ collapsed }) => ({ collapsed: !collapsed }))

  openProfile = () => {
    if (isResale() || isUserResale()) this.openResaleProfile()
  }

  openResaleProfile = () => {
    const { id } = getUser()
    this.props.history.push(`/revendas/${id}`)
  }

  openUserProfile = () => {
    const { userId } = getUser()
    findUser(userId)
      .then(user => this.setState(prevState => ({ userFormIsOpen: !prevState.userFormIsOpen, user })))
      .catch(error => message.error(error))
  }

  openConfig = () =>
    getConfiguration()
      .then(configuration =>
        this.setState(({ resaleRatioFormIsOpen }) => ({
          resaleRatioFormIsOpen: !resaleRatioFormIsOpen,
          configuration
        }))
      )
      .catch(error => message.error(error))

  openParameters = () => {
    const { id } = getUser()
    this.props.history.push(`/parametros-operacao/${id}`)
  }

  closeUserForm = callback => {
    this.setState({ userFormIsOpen: false, user: {} }, () => {
      callback.reset()
      if (callback.user) {
        this.props.dispatch(updateProfile(callback.user))
      }
    })
  }

  closeResaleRatioForm = callback => {
    this.setState({ resaleRatioFormIsOpen: false, user: {} }, () => {
      callback();
    })
  }

  logOut = () => {
    this.props.logOut();
    this.props.history.push(`/login`)
  }

  handleOnClose = async () => {
    await this.setState({ pedidoSelecionado: false });
  };

  render() {
    const { collapsed, userFormIsOpen, user, resaleRatioFormIsOpen,
      configuration, isSoundMuted, loadingMenus, employeeMenus, isSoundEnabled } = this.state

    return (
      <Layout>
        <SideBar
          employeeMenus={employeeMenus}
          loading={loadingMenus}
          logOut={() => this.logOut()}
          openConfig={this.openConfig}
          openUserProfile={this.openUserProfile}
          openParameters={this.openParameters}
          openProfile={this.openProfile}
          isCollapsed={collapsed} />
        <Layout>
          <Header
            openParameters={this.openParameters}
            openProfile={this.openProfile}
            onToggle={this.toggle}
            onNotificationClick={this.onNotificationClick}
            toggleSoundMute={this.toggleSoundMute}
            muted={isSoundMuted}
            isCollapsed={collapsed} />
          {this.props.children}
          <UsuarioFormulario
            user={user}
            onClose={this.closeUserForm}
            isOpen={userFormIsOpen} />
          {resaleRatioFormIsOpen && (
            <ConfiguracaoGeralFormulario
              configuration={configuration}
              onClose={this.closeResaleRatioForm}
              isOpen={resaleRatioFormIsOpen} />
          )}
          {this.state.pedidoSelecionado && (
            <DetalhePedido
              onClose={this.handleOnClose}
              orderId={this.state.orderId}
              isOpen={this.state.pedidoSelecionado}
            />
          )}
          <OrderSoundPlayer isSoundEnabled={!isSoundMuted && isSoundEnabled} />
        </Layout>
      </Layout>
    )
  }
}

const mapActionToProps = dispatch =>
  bindActionCreators({ dispatch, updateProfile, logOut, addNewNotification, readNotification }, dispatch)

const mapStateToProps = ({ account, notifications }) => ({ account, notifications })

export default withRouter(connect(mapStateToProps, mapActionToProps)(UpgasLayout))
